import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getFeatureFlags } from 'utils/featureFlags/selectors';

import Button from '@material-ui/core/Button';
import QButton from 'components/QButton';

import Typography from '@material-ui/core/Typography';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles/index';

import { removeDialog } from 'data/rootUi/actions';

import { DialogTimeout, styles } from './styles';

class AlertDialog extends React.PureComponent {

  handleClose = (btn) => {
    if (this.props.onClose) {
      this.props.onClose({ btnPressed: btn });
    }
    this.props.removeDialog(this.props.dialogId);
  };

  renderButtons = () => {

    const newBtns = this.props.customDialogButtons;

    const BtnComponent = newBtns ? QButton : Button;
    const btn1Variant = newBtns ? 'outlined' : 'text';
    const btn2Variant = newBtns ? 'contained' : 'text';

    const btns = [];
    this.props.buttons?.forEach((btn, index) => btns.push(
      <BtnComponent
        variant={index === this.props.buttons.length - 1 ? btn2Variant : btn1Variant}
        id={`alrtdlg:${btn}`}
        key={`alrtdlg:${btn}`}
        onClick={() => this.handleClose(btn)} color="primary"
      >
        {btn}
      </BtnComponent>
    ));
    return btns;
  };

  render() {
    const { classes } = this.props; // eslint-disable-line no-unused-vars

    const isString = typeof this.props.content === 'string';

    return (
      <Dialog
        open
        onClose={() => { this.handleClose('Escape'); }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: this.props.paperStyle }}
        classes={{ root: this.props.rootStyle }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            this.handleClose(this.props.buttons && this.props.buttons.length > 0 && this.props.buttons[this.props.buttons.length - 1]);
          } else if (event.key === 'Escape') {
            this.handleClose(this.props.buttons && this.props.buttons.length > 0 && this.props.buttons[0]);
          }
        }}
      >
        <DialogTitle className={classes.titleArea} id="alert-dialog-title">
          {this.props.titleIcon}
          {this.props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContent
            id="alert-dialog-description"
            className={classes.textContent}
            style={{ paddingTop: 16 }}
          >
            {isString &&
              <Typography className={classes.textArea} variant="subtitle1">
                {this.props.content}
              </Typography>
            }
            {!isString &&
              <>
                {this.props.content}
              </>
            }

          </DialogContent>

          {(this.props.timeout > -1) &&
          <DialogTimeout>
            {this.props.timeout}
          </DialogTimeout>
          }

        </DialogContent>
        <DialogActions style={{ paddingBottom: 24, paddingRight: 24, marginRight: 0 }}>
          {this.renderButtons()}
        </DialogActions>
      </Dialog>
    );
  }
}

AlertDialog.propTypes = {
  dialogId: PropTypes.string,
  onClose: PropTypes.func,
  buttons: PropTypes.array,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  title: PropTypes.string,
  titleIcon: PropTypes.object,
  timeout: PropTypes.number,
  classes: PropTypes.object,
  removeDialog: PropTypes.func,
  paperStyle: PropTypes.object,
  rootStyle: PropTypes.string,
  customDialogButtons: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    customDialogButtons: getFeatureFlags(state).get('customDialogButtons'),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    removeDialog: (props) => dispatch(removeDialog(props)),
  };
}

export default compose(
  withStyles(styles, { name: 'AlertDialog' }),
  connect(mapStateToProps, mapDispatchToProps),
)(AlertDialog);

